import { data_create_api_resource } from '@/utils/http_functions';
import API from "@/services/api";
import { IUpdateInvoiceOnline } from '../types/changeInvoiceOnlineDialog';

enum Endpoints {
  UpdateInvoiceOnline = "/contracts/:contract_name",
}

const updateInvoiceOnline = async (
  dades: IUpdateInvoiceOnline
): Promise<Boolean> => {
  try {
    const response = await API.post<
      Boolean,
      {
        invoice_online: string
      }
    >({
      endpoint: Endpoints.UpdateInvoiceOnline,
      params: {
        contract_name: dades.contractName
      },
      data: {
        invoice_online: dades.sendMethod
      },
      versions: [2]
    });
    return response.promise.data;
  } catch (error) {
    throw new Error("Failed to load the newsletters. Please try again later.");
  }
};

export default {
  updateInvoiceOnline
};